import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  token: '',
  refreshToken: '',
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    login: (state, action) => ({ ...state, token: action.payload.token || '', refreshToken: action.payload.refreshToken || '' }),
    resetAuth: () => initialState,
  },
});

export const { login, resetAuth } = authSlice.actions;
export default authSlice.reducer;
